const Navigators = {
};

Navigators.install = function (Vue) {
    Vue.prototype.$goToCatalogProduct = (router, type, name, category,status,bundling, itemPerPage,page, typeName, categoryName) => {
       router.push({path:'/catalog',
            query: {
                type: type,
                typeName:typeName,
                name: name,
                category: category,
                categoryName: categoryName,
                status: status,
                itemPerPage: itemPerPage,
                page:page
            }
        })
    };
    Vue.prototype.$toCatalogProduct = (router) => {
       Vue.prototype.$goToCatalogProduct(router,"All",'',"All","All","All",10,1,"All","All")
    };
    Vue.prototype.$goToSparepart = (router, sku, type, name, page, itemPerPage) => {
        if(page == ""){
            page="All"
        }
       router.push({
            path: '/sparepart',
            query: {
                sku: sku,
                type: type,
                name:name,
                page:page,
                itemPerPage: itemPerPage,
            }
        })
    };
    Vue.prototype.$goToDisposal = (router, disposalId, disposalDate, createdBy, erpTrxId, jurnalTrxId, status, page, itemPerPage) => {
        router.push({
            path: '/disposal',
            query: {
                disposalId: disposalId,
                disposalDate: disposalDate,
                createdBy: createdBy,
                erpTrxId: erpTrxId,
                jurnalTrxId: jurnalTrxId,
                status: status,
                page: page,
                itemPerPage: itemPerPage,
            }
        })
    };
};
export default Navigators;



// WEBPACK FOOTER //
// ./src/components/navigators.js